import Axios from "axios";

const ttsEvaluationClient = Axios.create({
  baseURL: process.env.REACT_APP_TTS_EVALUATION_ORIGIN,
  withCredentials: true,
});

export interface VoiceEvalScore {
  avg: number;
  count: number;
  scaleMin: number;
  scaleMax: number;
  scope: string;
  dimension: string;
}

export interface VoiceEvalEntry {
  evalName: string;
  evalType: string;
  languageId: string | null;
  createdAt: string;
  scores: Record<string, VoiceEvalScore>;
}

export interface VoiceEvalResults {
  voiceName: string;
  voiceProvider: string;
  voiceVersion: number;
  aggregateScores: Record<string, VoiceEvalScore>;
  qualityBadge: "high" | "acceptable" | "low" | null;
  evals: VoiceEvalEntry[];
}

export const getResultsByVoice = async (
  voiceName: string,
  voiceProvider: string,
  voiceVersion: number,
): Promise<VoiceEvalResults> =>
  (
    await ttsEvaluationClient.get<VoiceEvalResults>(
      "/api/v2/results/by-voice",
      {
        params: {
          voice_name: voiceName,
          voice_provider: voiceProvider,
          voice_version: voiceVersion,
        },
      },
    )
  ).data;

export interface VoiceBadgesResponse {
  badges: Record<string, "high" | "acceptable" | "low" | null>;
}

export const getVoiceBadges = async (
  voices: { name: string; provider: string; version: number }[],
): Promise<VoiceBadgesResponse> =>
  (
    await ttsEvaluationClient.post<VoiceBadgesResponse>(
      "/api/v2/results/voice-badges",
      { voices },
    )
  ).data;
